/* Neck page (nk-* sections). Vanilla, no dependencies. Each module runs only if its markup exists.
   Prices come from #NkConfig (printed by the hero section) through window.nkFill (inline there). */
(function () {
  if (window.__nk) return;
  window.__nk = true;
  var d = document, html = d.documentElement;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var desk = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: true };
  // phones (below the 750 tablet breakpoint): the phone-only layouts in nk.css match this
  var phone = window.matchMedia ? matchMedia('(max-width: 749.98px)') : { matches: false };
  var calm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function onPhoneChange(fn) { if (phone.addEventListener) phone.addEventListener('change', fn); else if (phone.addListener) phone.addListener(fn); }

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function cfg() { return window.nkCfg ? window.nkCfg() : null; }
  function track(name, data) {
    data = Object.assign({ page: 'neck' }, data || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function run(fn, arg) { try { fn(arg); } catch (e) { if (window.console) console.error('[nk]', e); } }
  function live(text) {
    var el = $('[data-nk-live]'); if (!el) return;
    el.textContent = ''; setTimeout(function () { el.textContent = text; }, 60);
  }
  // in-page jumps on phones: the site header (layout/theme.liquid) slides back in on any upward
  // scroll, so a jump UP lands below it; a jump down hides it, so only the scroll margin counts
  function jump(el, smooth) {
    var m = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    var y = el.getBoundingClientRect().top + pageYOffset - m;
    if (y < pageYOffset - 2) {
      var hd = $('.shopify-section--header');
      y -= hd ? hd.offsetHeight : (parseFloat(getComputedStyle(html).getPropertyValue('--header-height')) || 0);
    }
    scrollTo({ top: Math.max(0, Math.round(y)), behavior: smooth && !calm ? 'smooth' : 'auto' });
  }

  ready(function () {
    if (window.nkFill) window.nkFill(d);
    [buyClicks, gallery, switcher, rowLinks, rails, dock, tabs, accs, more, videos, clips, expiry].forEach(function (f) { run(f); });
    var ref = d.referrer || '', entry = /youtube\.|youtu\.be/.test(ref) ? 'youtube' : (ref.indexOf(location.host) > -1 ? 'site' : (ref ? 'other' : 'direct'));
    track('neck_page_view', { entry: entry });
    if (window.Shopify && Shopify.designMode) {
      run(hints);
      d.addEventListener('shopify:section:load', function (e) {
        if (window.nkFill) window.nkFill(d);
        [gallery, switcher, rails, tabs, accs, more, clips, dock, hints].forEach(function (f) { run(f); });
        if (dock.collect) run(dock.collect);
      });
      d.addEventListener('shopify:block:select', function (e) {
        var t = e.target;
        var panel = t.closest('[role=tabpanel]');
        if (panel && panel.hidden) { var tb = $('[data-nk-tab="' + panel.getAttribute('data-nk-panel') + '"]', panel.closest('section')); if (tb) tb.click(); }
        var det = t.closest('details'); if (det) det.open = true;
        if (t.tagName === 'DETAILS') t.open = true;
        var revs = t.closest('[data-nk-revs]'); if (revs) revs.classList.add('is-open');
        var row = t.closest('.nk-prod'); if (row) { var rs = row.closest('section'); if (rs && rs._nkShow) rs._nkShow(row.id); }
      });
    }
  });

  /* ---------- add to cart (one path for the set, a product, or several products) ----------
     Keeps the shopper's cart and their own codes: /cart/update.js REPLACES the code list, so ours
     are merged with what's there. Codes go in first, then /cart/add.js (Rebuy's cart opens by
     itself), then any of our codes the cart says don't apply are dropped again and the shopper is
     told which product is at its regular price. */
  var TIMEOUT = 12000;
  function timed(u, opts) {
    // a hung request falls into the normal error path (label back, our codes rolled back)
    var ctl = window.AbortController ? new AbortController() : null, t;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, TIMEOUT); }
    return fetch(root + u, opts).then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }
  function getJSON(u) {
    return timed(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function post(u, body) {
    return timed(u, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }
  function utm() {
    var o = {}, q = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (q.get(k)) o['nk_' + k] = q.get(k).slice(0, 80); });
    return o;
  }
  function U(x) { return String(x || '').trim().toUpperCase(); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
  function msgFor(btn) {
    var box = btn.closest('.nk-card, .nk-choice, .nk-prod__buy, .nk-close__offer, .nk-quick__i, .nk-callout, .nk-prods__foot');
    return box ? $('[data-nk-msg]', box) : null;
  }
  var toastT;
  function toast(text) {
    var t = $('.nk-toast');
    if (!t) { t = d.createElement('div'); t.className = 'nk-toast'; d.body.appendChild(t); }
    t.textContent = text; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 7000);
  }
  function say(btn, text) {
    // one visible copy (inline note if it is on screen, otherwise a toast) and one announcement
    var m = btn.closest('.nk-dock') ? null : msgFor(btn), visible = false;
    if (m) {
      m.textContent = text;
      var r = m.getBoundingClientRect();
      visible = r.height > 0 && r.top < innerHeight && r.bottom > 0;
    }
    if (!visible) toast(text);
    live(text);
  }

  function buy(key, place, btn) {
    var c = cfg(); if (!c) { location.href = btn.getAttribute('href'); return; }
    if (btn.getAttribute('aria-busy') === 'true') return;
    var ids = key === 'bundle' ? c.bundle.ids : key.split(',').map(function (s) { return s.trim(); });
    var items = ids.map(function (id) { return c.products[id] && Object.assign({ id: id }, c.products[id]); })
      .filter(function (p) { return p && p.available; });
    if (!items.length) { say(btn, c.msgs.soldOut); return; }
    var ours = items.filter(function (p) { return p.live && p.code; }).map(function (p) { return p.code; });
    if (key === 'bundle' && c.bundle.live && c.bundle.extraCode) ours.push(c.bundle.extraCode);
    ours = ours.filter(function (x, i) { return ours.map(U).indexOf(U(x)) === i; });

    var label = $('[data-nk-label]', btn), orig = label ? label.innerHTML : '';
    var m = msgFor(btn); if (m) m.textContent = '';
    btn.setAttribute('aria-busy', 'true'); btn.classList.remove('is-added');
    if (label) label.textContent = c.msgs.busy || 'Adding…';
    function reset(ms) { setTimeout(function () { if (label) label.innerHTML = orig; btn.removeAttribute('aria-busy'); btn.classList.remove('is-added'); }, ms); }

    var had = [], hadU = [], value = items.reduce(function (s, p) { return s + p.priceCents; }, 0);
    var attrs = Object.assign({ nk_source: c.source || 'neck-lp', nk_placement: place }, utm());
    var mine = function () { return ours.filter(function (x) { return hadU.indexOf(U(x)) < 0; }); };
    var codesFail = false, codesSent = false, added = false;
    getJSON('cart.js').then(function (cart) {
      had = codesOf(cart); hadU = had.map(U);
      var body = { attributes: attrs };
      if (mine().length) { body.discount = had.concat(mine()).join(','); codesSent = true; }
      return post('cart/update.js', body);
    }).then(function (r) {
      // codes didn't go in (e.g. 422 or 429): still add the items, then tell the shopper
      if (!r.ok && mine().length) codesFail = true;
      return post('cart/add.js', { items: items.map(function (p) { return { id: p.variantId, quantity: 1 }; }) });
    }).then(function (r) {
      if (r.ok) { added = true; return r.json(); }
      return r.json().catch(function () { return {}; }).then(function (e) {
        var err = new Error('add'); err.detail = e && (e.description || e.message); throw err;
      });
    }).then(function () {
      return ours.length ? getJSON('cart.js') : null;
    }).then(function (after) {
      var dead = [];
      if (after) {
        // ours that the cart did not accept: listed as not applicable, or missing from the list
        dead = mine().filter(function (x) {
          return !(after.discount_codes || []).some(function (y) { return U(y.code) === U(x) && y.applicable; });
        });
        if (codesFail && !dead.length) dead = mine();
        if (dead.length) {
          var deadU = dead.map(U);
          var keep = codesOf(after).filter(function (x) { return deadU.indexOf(U(x)) < 0; });
          post('cart/update.js', { discount: keep.join(',') }).then(refreshCart, function () {});
          var names = items.filter(function (p) { return p.code && deadU.indexOf(U(p.code)) > -1; }).map(function (p) { return p.name; });
          if (!names.length) names = [c.bundle.name];
          var nm = names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
          say(btn, (c.msgs.code || '').replace('[name]', nm));
          track('neck_code_not_applied', { codes: dead.join(','), placement: place });
        }
      }
      if (label) label.textContent = c.msgs.done || 'Added';
      btn.classList.add('is-added');
      if (!dead.length) live((key === 'bundle' ? c.bundle.name : items.map(function (p) { return p.name; }).join(', ')) + ' added to your cart.');
      track('neck_add_to_cart', { placement: place, key: key === 'bundle' ? 'set' : (ids.length > 1 ? 'several' : 'single'), items: items.length, value: value / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      refreshCart();
      if (!window.Rebuy && !d.querySelector('cart-drawer, #rebuy-cart')) setTimeout(function () { location.href = root + 'cart'; }, 400);
      reset(2200);
    }).catch(function (e) {
      if (added) { refreshCart(); reset(0); return; }
      // roll our codes back so a failed or timed-out add leaves the cart as it was
      if (codesSent && !added) post('cart/update.js', { discount: had.join(',') }).catch(function () {});
      say(btn, (e && e.detail && /sold out|available/i.test(e.detail) ? e.detail + ' ' : '') + (c.msgs.error || ''));
      track('neck_add_to_cart_error', { placement: place });
      if (label) label.innerHTML = orig; btn.removeAttribute('aria-busy');
    });
  }
  function refreshCart() {
    // Rebuy re-renders by itself; the theme cart only needs a refresh (opening it too would lock the page behind Rebuy)
    html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: !(window.Rebuy && Rebuy.SmartCart) } }));
  }
  function buyClicks() {
    if (buyClicks.on) return; buyClicks.on = true;
    // capture on window: runs before theme/app listeners that intercept /cart/add links
    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-nk-add]'); if (!btn) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      buy(btn.getAttribute('data-nk-add'), btn.getAttribute('data-nk-place') || 'page', btn);
    }, true);
  }

  /* ---------- theme editor only: products shown below that the hero doesn't price ---------- */
  function hints() {
    var el = d.getElementById('NkConfig'), base; try { base = JSON.parse(el.textContent).products; } catch (e) { return; }
    $$('script[data-nk-extra]').forEach(function (x) {
      var e; try { e = JSON.parse(x.textContent); } catch (er) { return; }
      var miss = Object.keys(e).filter(function (k) { return !base[k]; }).map(function (k) { return e[k].name; });
      var sec = x.closest('section'), old = sec && $('.nk-hints--extra', sec);
      if (old) old.remove();
      if (!sec || !miss.length) return;
      var h = d.createElement('div'); h.className = 'nk-hints nk-hints--extra';
      h.textContent = miss.join(', ') + ': not a "Product in the set" block in the Hero section, so it sells at today\'s price with no code. Add it there to give it the sale price.';
      sec.insertBefore(h, sec.firstChild);
    });
  }

  /* ---------- hero gallery ---------- */
  function gallery() {
    $$('[data-nk-gallery]').forEach(function (g) {
      if (g._nk) return; g._nk = true;
      var track_ = $('[data-nk-track]', g), slides = $$('.nk-gal__slide', g), thumbs = $$('[data-nk-thumb]', g), cur = $('[data-nk-current]', g);
      if (!track_ || slides.length < 2) return;
      // photos after the first (and the computer thumbnails) load lazily: switch them to eager once
      // the gallery is near the screen, so a swipe never shows an empty slide
      var lazy = $$('img[loading="lazy"]', g);
      if (lazy.length && 'IntersectionObserver' in window) {
        var lio = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          lazy.forEach(function (i) { i.loading = 'eager'; }); lio.disconnect();
        }, { rootMargin: '800px 0px' });
        lio.observe(g);
      }
      var idx = 0, seen = false;
      function go(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track_.scrollTo({ left: slides[i].offsetLeft - track_.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = Math.round(track_.scrollLeft / Math.max(1, track_.clientWidth));
        if (i === idx) return; idx = i;
        if (cur) cur.textContent = i + 1;
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        if (!seen) { seen = true; track('neck_gallery_swipe'); }
      }
      var raf;
      track_.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-nk-thumb')); }); });
      var prev = $('[data-nk-prev]', g), next = $('[data-nk-next]', g);
      if (prev) prev.addEventListener('click', function () { go(idx === 0 ? slides.length - 1 : idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx === slides.length - 1 ? 0 : idx + 1); });
      track_.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
    });
  }

  /* ---------- bottom buy bar ----------
     On whenever the hero's Add button is off screen (scrolled away, or still below the first screen
     on a phone); off over the closing band and below it, while
     a theme drawer is open, and while Shopify's floating cookie card is waiting for an answer. */
  function dock() {
    var bar = $('[data-nk-dock]'), anchor = $('[data-nk-dock-anchor]');
    if (!bar || !anchor || dock.on) return; dock.on = true;
    var shown = false, ticking = false, lastOff = -1, floating = false, state = null, heroOn = null, inline = [];
    // phones: the other "Add the set" buttons in the page (the bar never shows next to one of them)
    dock.collect = function () {
      inline = $$('[data-nk-add="bundle"]').filter(function (b) { return !bar.contains(b) && !b.hasAttribute('data-nk-dock-anchor'); });
    };
    dock.collect();
    var COVERS = '#cb-cookie_consent .cb-cookie_consent-container, #shopify-pc__banner';
    function offset() {
      var vh = innerHeight, vw = innerWidth, off = 0, fl = false;
      $$(COVERS).forEach(function (b) {
        var cs = getComputedStyle(b); if (cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = b.getBoundingClientRect(); if (!(r.height > 0 && r.top < vh && r.bottom > vh - 40)) return;
        if (r.width < vw * 0.9 || r.height > vh * 0.3) { fl = true; return; }
        off = Math.max(off, Math.round(vh - r.top));
      });
      floating = fl;
      if (off !== lastOff) { lastOff = off; html.style.setProperty('--nk-dock-offset', off + 'px'); }
    }
    function update() {
      ticking = false;
      var a = $('[data-nk-dock-anchor]'); if (!a) return;
      offset();
      var vh = innerHeight, r = a.getBoundingClientRect(), past;
      if (phone.matches) {
        // phones: on once the hero button is not fully on screen, and never next to another "Add the set"
        past = (r.bottom < 0 || r.bottom > vh) && !inline.some(function (b) {
          var q = b.getBoundingClientRect(); return q.height > 0 && q.top < vh - 60 && q.bottom > 0;
        });
      } else {
        past = r.bottom < 0 || r.top > vh - 80;
      }
      var hide = $$('[data-nk-hide-dock]').some(function (el) { return el.getBoundingClientRect().top < vh * 0.85; });
      var on = past && !hide && !floating;
      if (on !== state) {
        state = on;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        html.classList.toggle('nk-dock-on', on);
        if (on && !shown) { shown = true; track('neck_dock_shown'); }
      }
      // phones: the chat bubble stays away while the hero fills the lower half of the screen
      var offer = $('[data-nk-offer]');
      var ho = !!(phone.matches && offer && offer.getBoundingClientRect().bottom > vh * 0.5);
      if (ho !== heroOn) { heroOn = ho; html.classList.toggle('nk-hero-on', ho); }
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', req);
    onPhoneChange(req);
    d.addEventListener('click', function () { setTimeout(req, 400); }, true);
    [800, 2000, 5000].forEach(function (t) { setTimeout(req, t); });
    update();
  }

  /* ---------- weekly plan tabs ---------- */
  function tabs() {
    $$('[data-nk-tabs]').forEach(function (list) {
      if (list._nk) return; list._nk = true;
      var bs = $$('[role=tab]', list), sec = list.closest('section');
      function select(i, focus) {
        bs.forEach(function (b, j) {
          var on = j === i, p = $('[data-nk-panel="' + b.getAttribute('data-nk-tab') + '"]', sec);
          b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          if (p) p.hidden = !on;
          if (on && focus) b.focus();
        });
      }
      bs.forEach(function (b, i) { b.addEventListener('click', function () { select(i); track('neck_plan_tab', { tab: b.getAttribute('data-nk-tab') }); }); });
      list.addEventListener('keydown', function (e) {
        var i = bs.indexOf(d.activeElement); if (i < 0) return;
        var to = e.key === 'ArrowRight' ? (i + 1) % bs.length : e.key === 'ArrowLeft' ? (i - 1 + bs.length) % bs.length : e.key === 'Home' ? 0 : e.key === 'End' ? bs.length - 1 : -1;
        if (to > -1) { e.preventDefault(); select(to, true); }
      });
    });
  }

  /* ---------- product panels: closed everywhere, so the rows stay short; [data-nk-acc="open"] opens on computers ---------- */
  function accs() {
    if (!desk.matches) return;
    $$('[data-nk-acc="open"]').forEach(function (a) { if (!a._nk) { a._nk = true; a.open = true; } });
  }

  /* ---------- customer clips: load + play muted only while on screen; tap for sound ---------- */
  function clips() {
    var figs = $$('[data-nk-clip]').filter(function (f) { return !f._nk; });
    if (!figs.length) return;
    var still = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || (navigator.connection && navigator.connection.saveData);
    function load(v) { if (!v.src && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); } }
    function play(v) { load(v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    var hasIO = 'IntersectionObserver' in window;
    // computers and tablets: each clip plays while it is on screen
    var io = hasIO ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = $('video', e.target); if (!v) return;
        if (e.isIntersecting) { if (!still || !v.muted) play(v); } else if (!v.paused) v.pause();
      });
    }, { threshold: 0.45 }) : null;
    // phones: only the most visible clip plays (the row shows one and a half clips at a time)
    function pick() {
      var best = null;
      figs.forEach(function (f) { var r = f._nkR || 0; if (r >= 0.45 && (!best || r > best._nkR)) best = f; });
      figs.forEach(function (f) {
        var v = $('video', f); if (!v) return;
        if (f === best) { if (!still || !v.muted) play(v); } else if (!v.paused) v.pause();
      });
    }
    var ioP = hasIO ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target._nkR = e.isIntersecting ? e.intersectionRatio : 0; });
      pick();
    }, { threshold: [0, 0.25, 0.45, 0.6, 0.75, 0.9, 1] }) : null;
    function watch() {
      if (!hasIO) return;
      io.disconnect(); ioP.disconnect();
      figs.forEach(function (f) { if ($('video', f)) (phone.matches ? ioP : io).observe(f); });
    }
    if (hasIO) { watch(); onPhoneChange(watch); }
    figs.forEach(function (f) {
      f._nk = true;
      var v = $('video', f), b = $('[data-nk-sound]', f); if (!v) return;
      if (!hasIO && !still) play(v);
      function toggle() {
        var on = v.muted;
        $$('[data-nk-clip] video').forEach(function (o) { if (o !== v && !o.muted) { o.muted = true; var ob = $('[data-nk-sound]', o.parentNode); if (ob) ob.setAttribute('aria-pressed', 'false'); } });
        v.muted = !on; if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { v.currentTime = 0; play(v); track('neck_ugc_sound', { clip: v.getAttribute('aria-label') || '' }); }
      }
      if (b) b.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      v.addEventListener('click', toggle);
    });
  }

  /* ---------- products on phones: four photo buttons pick which write-up shows ----------
     .nk-prods gets .is-switch on phones only (the CSS hides the other rows there). Each row keeps its
     own price, button and review. Computers and tablets always show all four rows. */
  function switcher() {
    $$('[data-nk-switch]').forEach(function (sw) {
      if (sw._nk) return; sw._nk = true;
      var sec = sw.closest('section'), list = sec && $('.nk-prods', sec);
      var rows = list ? $$('.nk-prod', list) : [], btns = $$('.nk-switch__b', sw);
      if (rows.length < 2) return;
      var ids = rows.map(function (r) { return r.id; }), cur = ids[0], h = '';
      try { h = decodeURIComponent((location.hash || '').slice(1)); } catch (e) {}
      if (ids.indexOf(h) > -1) cur = h;
      function show(id, via) {
        if (ids.indexOf(id) < 0) return false;
        cur = id;
        rows.forEach(function (r) { r.classList.toggle('is-on', r.id === id); });
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nk-switch-to') === id ? 'true' : 'false'); });
        if (via) track('neck_product_switch', { product: id, via: via });
        return true;
      }
      function go(id, via) {
        if (!phone.matches || !show(id, via)) return false;
        jump(sw, true);
        var row = d.getElementById(id), hd = row && $('.nk-prod__name', row);
        if (hd) { try { hd.focus({ preventScroll: true }); } catch (e) {} }
        return true;
      }
      function apply() { list.classList.toggle('is-switch', !!phone.matches); show(cur); }
      sec._nkShow = function (id) { show(id); };
      sec._nkGo = go;
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-nk-switch-to'), 'bar'); }); });
      sec.addEventListener('click', function (e) {
        var n = e.target.closest && e.target.closest('[data-nk-switch-via]');
        if (n) go(n.getAttribute('data-nk-switch-to'), 'next');
      });
      onPhoneChange(apply);
      apply();
      if (h === cur && phone.matches) {
        // opened with #nk-p-...: land on the photo buttons (the browser's own jump can come later, so
        // repeat until the page has loaded, unless the shopper has started scrolling)
        var user = false, mark = function () { user = true; };
        ['touchstart', 'wheel', 'keydown'].forEach(function (ev) { addEventListener(ev, mark, { once: true, passive: true }); });
        var land = function () { if (!user) jump(sw, false); };
        [60, 400].forEach(function (t) { setTimeout(land, t); });
        if (d.readyState !== 'complete') addEventListener('load', function () { land(); [300, 1200].forEach(function (t) { setTimeout(land, t); }); }, { once: true });
        else setTimeout(land, 1200);
      }
    });
  }
  // phones: every link to a product row (#nk-p-...) on the page opens that row's write-up
  function rowLinks() {
    if (rowLinks.on) return; rowLinks.on = true;
    d.addEventListener('click', function (e) {
      if (!phone.matches || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a || a.hasAttribute('data-nk-add')) return;
      var id = a.getAttribute('href').slice(1), row = id && d.getElementById(id);
      if (!row) return;
      if (!row.classList.contains('nk-prod')) {
        // other jumps back UP the page (e.g. "Or buy them one at a time"): land below the site header
        if (row.closest('.nk') && row.getBoundingClientRect().top < 0) { e.preventDefault(); jump(row, true); }
        return;
      }
      var sec = row.closest('section');
      if (sec && sec._nkGo && sec._nkGo(id, 'link')) e.preventDefault();
    }, true);
  }

  /* ---------- swipe rows (reviews, customer clips): dots under the row on phones ---------- */
  function rails() {
    $$('[data-nk-rail]').forEach(function (r) {
      if (r._nk) return; r._nk = true;
      var items = Array.prototype.slice.call(r.children);
      if (items.length < 2) return;
      // phones: a row with nothing to tab to (reviews, the NEWA photo pair) takes focus itself, so
      // keyboard users can scroll it (Chrome does this by itself, Safari does not)
      if (phone.matches && !$('a,button,[tabindex]', r) && !r.hasAttribute('tabindex')) {
        r.tabIndex = 0;
        if (!r.hasAttribute('aria-label')) r.setAttribute('aria-label', 'Swipe for more');
      }
      var dots = d.createElement('div'); dots.className = 'nk-dots'; dots.setAttribute('aria-hidden', 'true');
      items.forEach(function () { dots.appendChild(d.createElement('i')); });
      r.parentNode.insertBefore(dots, r.nextSibling);
      // first dot on from the start: a row that is hidden at load (a product write-up not picked yet)
      // can't measure itself until it shows
      var is = $$('i', dots), idx = 0, raf, seen = false, rev = r.hasAttribute('data-nk-revs');
      is[0].classList.add('is-on');
      function sync() {
        var step = items[1].offsetLeft - items[0].offsetLeft, max = r.scrollWidth - r.clientWidth;
        if (step <= 0) return;
        var i = r.scrollLeft >= max - 2 ? items.length - 1 : Math.round(r.scrollLeft / step);
        i = Math.max(0, Math.min(items.length - 1, i));
        if (i !== idx) { idx = i; is.forEach(function (x, j) { x.classList.toggle('is-on', j === i); }); }
        if (rev && !seen && r.scrollLeft > 10) { seen = true; track('neck_reviews_swipe'); }
      }
      r.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- reviews: show more on phones ---------- */
  function more() {
    $$('[data-nk-more]').forEach(function (b) {
      if (b._nk) return; b._nk = true;
      var g = b.parentNode.querySelector('[data-nk-revs]'), txt = b.textContent;
      if (!g) return;
      b.addEventListener('click', function () {
        var open = g.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? (b.getAttribute('data-less') || txt) : txt;
        if (open) { var f = $('.is-more', g); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } track('neck_reviews_more'); }
      });
    });
  }

  /* ---------- YouTube: nothing loads until a click ---------- */
  function videos() {
    if (videos.on) return; videos.on = true;
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nk-yt]'); if (!b) return;
      var id = b.getAttribute('data-nk-yt'), start = +b.getAttribute('data-start') || 0, frame = b.closest('[data-nk-frame]');
      if (!id || !frame) return;
      var f = d.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' + (start ? '&start=' + start : '');
      f.title = b.getAttribute('data-title') || 'YouTube video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      frame.innerHTML = ''; frame.appendChild(f); f.focus();
      track('neck_video_play', { video: id, start: start });
    });
  }

  /* ---------- offer end date: after it passes the page switches to regular prices ---------- */
  function expiry() {
    var c = cfg(); if (!c || !c.offerEnds || !c.offerLive) return;
    var left = c.offerEnds - Date.now();
    if (left <= 0) expire(); else if (left < 2147483000) setTimeout(expire, left);
  }
  function expire() {
    var el = d.getElementById('NkConfig'); if (!el) return;
    var c; try { c = JSON.parse(el.textContent); } catch (e) { return; }
    var mf = c.moneyFormat;
    Object.keys(c.products).forEach(function (k) {
      var p = c.products[k];
      p.live = false; p.code = null; p.pct = 0; p.priceCents = p.fullCents; p.price = p.full; p.save = window.nkMoney ? nkMoney(0, mf) : '$0';
      p.fallback = '/cart/add?id=' + p.variantId + '&quantity=1&return_to=/cart';
    });
    var b = c.bundle;
    b.live = false; b.priceCents = b.fullCents; b.price = b.full; b.pct = 0; b.extraCode = null;
    b.fallback = String(b.fallback || '').split('?')[0];
    c.offerLive = false;
    el.textContent = JSON.stringify(c);
    $$('[data-nk-sale-only]').forEach(function (x) { x.hidden = true; });
    $$('[data-nk-expired]').forEach(function (x) { x.hidden = false; });
    if (window.nkFill) window.nkFill(d);
  }
})();
